import { inMemoryStorageFactory, scrileConnect as ProvidersFactory } from "@scrile/api-provider/dist/";
import Configuration from "@scrile/api-provider/dist/Configuration";
import { IS_BROWSER } from "@/lib/browserUtils";
import emitter from "@/lib/emitter";
import config from "@/config";
import AppStorage from "./appStorage";

export enum ProviderPrefix {
  MANAGER = "MANAGER",
  ADMIN = "admin",
}

interface ProvidersInfo {
  providers: ReturnType<typeof ProvidersFactory> | undefined;
  useCount: number;
}

const additionalProviders: Record<ProviderPrefix, ProvidersInfo> = {} as Record<ProviderPrefix, ProvidersInfo>;

export const initAdditionalProviders = (prefix: ProviderPrefix) => {
  const providers = ProvidersFactory({
    url: config.apiUrl,
    notificationCB: () => {},
    appStorage: AppStorage,
    websocketOnly: true,
    prefix,
  });
  additionalProviders[prefix] = {
    providers,
    useCount: 1,
  };
  return providers;
};

export const getAdditionalProviders = (prefix: ProviderPrefix): ReturnType<typeof ProvidersFactory> => {
  let providers = additionalProviders[prefix]?.providers;
  if (!providers) providers = initAdditionalProviders(prefix);
  else {
    additionalProviders[prefix].useCount++;
  }

  return providers;
};

export const closeAdditionalProvidersConnection = (prefix: ProviderPrefix) => {
  additionalProviders[prefix].useCount--;
  if (additionalProviders[prefix].useCount === 0) {
    additionalProviders[prefix].providers?.apiTools?.close();
    delete additionalProviders[prefix];
  }
};

export const getManagerProviders = () => getAdditionalProviders(ProviderPrefix.MANAGER);

export const getMemoryProviders = (prefix?: string) =>
  ProvidersFactory({
    url: config.apiUrl,
    notificationCB: () => {},
    appStorage: inMemoryStorageFactory(),
    websocketOnly: true,
    prefix,
  });

const providers = ProvidersFactory({
  url: config.apiUrl,
  notificationCB: (event, payload) => {
    emitter.emit(event, payload);
  },
  appStorage: AppStorage,
  websocketOnly: true,
  ...(!IS_BROWSER
    ? {
        fetch: require("node-fetch").default,
        webSocketImpl: require("websocket").w3cwebsocket,
      }
    : {}),
});

Configuration.featureLiveChat = config.featureGoLive;
Configuration.featurePaidMessageAttachments = true;
Configuration.featureFeedPublicReview = config.featureFeedPublicReview;

export default providers.providers;
export const apiTools = providers.apiTools;
